import { Currencies } from '../types';
import {api} from './api';

export interface CompanyVendorProfile {
	id: number,
	name: string,
	legalName: string,
	currency: Currencies,
	address: string,
	taxId: string,
	website: string,
	vendorContactEmail: string
}


export interface CompanyProfile {
	id: number;
	name: string;
	bio: string;
	imgUrl: string | null;
	coverImgUrl: string | null;
	igChannelId: string | null;
	ytChannelId: string | null;
	pinterestChannelId: string | null;
	tiktokChannelId: string | null;
	roleCustomer: boolean;
	roleCreator: boolean;
	roleVendor: boolean;
	isVerified: boolean;
	createdAt: string;
	vendorProfile: CompanyVendorProfile | null;
}

export interface ShippingMethod {
	id: number;
	method: string;
	variant: string | null;
	price: number;
	description: string | null;
	shippingRegions: {countryCode: string, name: string}[];
}

export const companiesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getCompanyProfile: builder.query<CompanyProfile, string>({
			query: (profileId: string) => ({
				url: `company/${profileId}/profile`,
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		getCompanyShippingMethods: builder.query<ShippingMethod[], void>({
			query: () => ({
				url: 'companyShippingMethods',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		addCompanyShippingMethod: builder.mutation<ShippingMethod, Omit<ShippingMethod, 'id'>>({
			query: (shippingMethod: Omit<ShippingMethod, 'id'>) => ({
				url: 'companyShippingMethods',
				method: 'POST',
				body: shippingMethod,
			}),
		}),
		deleteCompanyShippingMethod: builder.mutation<void, number>({
			query: (id: number) => ({
				url: `companyShippingMethods/${id}`,
				method: 'DELETE',
			}),
		}),
		uploadCompanyImage: builder.mutation<{imgUrl: string}, FormData>({
			query: (formData: FormData) => ({
				url: 'company/uploadImage',
				method: 'POST',
				body: formData,
			}),
		}),
		uploadCompanyCoverImage: builder.mutation<{coverImgUrl: string}, FormData>({
			query: (formData: FormData) => ({
				url: 'company/uploadCoverImage',
				method: 'POST',
				body: formData,
			}),
		}),
	}),
});

export const { useGetCompanyProfileQuery, useGetCompanyShippingMethodsQuery, useAddCompanyShippingMethodMutation, useDeleteCompanyShippingMethodMutation, useUploadCompanyImageMutation, useUploadCompanyCoverImageMutation } = companiesApi;
